import { Badge } from '@/components/ui/badge'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import {
  ENQUIRY_STAGES,
  ENQUIRY_STAGE_LABELS,
  getEnquiryStageBadgeClass,
  getEnquiryStageLabel,
  type EnquiryStage,
} from '@/lib/sales-enquiry-stages'

type EnquiryStageSelectProps = {
  value: string
  onChange: (stage: EnquiryStage) => void
  disabled?: boolean
  compact?: boolean
}

export function EnquiryStageSelect({ value, onChange, disabled, compact }: EnquiryStageSelectProps) {
  const stageValue = String(value || 'new')
  const badgeClass = getEnquiryStageBadgeClass(stageValue)

  return (
    <Select value={stageValue} onValueChange={(next) => onChange(next as EnquiryStage)} disabled={disabled}>
      <SelectTrigger className={compact ? 'h-8 w-[148px] border-dashed' : 'w-[168px]'}>
        <SelectValue>
          <Badge variant="outline" className={badgeClass}>
            {getEnquiryStageLabel(stageValue)}
          </Badge>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {ENQUIRY_STAGES.map((stage) => (
          <SelectItem key={stage} value={stage}>
            {ENQUIRY_STAGE_LABELS[stage]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
